import { NgModule } from '@angular/core';
import { CommonModule, NgForOf, NgIf, NgOptimizedImage, NgStyle } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NewsListComponent } from './components/news-list/news-list.component';
import { NewsUrlPipe } from '../../helpers/pipes/news-url/news-url.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NewsPageComponent } from './components/news-page/news-page.component';
import { RegistryModule } from '../../registry/registry.module';
import { AccessGuard } from '../../guards/access.guard';
import { NotFoundComponent } from '../../pages/not-found/not-found.component';

/**
 * описание маршрутов
 */
const newsRoutes: Routes = [
  {
    path: 'news',
    component: NewsListComponent,
  },
  {
    path: 'news/new_buildings/:complexSlug',
    component: NewsListComponent,
  },
  {
    path: ':slug',
    component: NewsPageComponent
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  declarations: [
    NewsListComponent,
    NewsPageComponent,
  ],
    imports: [
        RouterModule.forChild(newsRoutes),
        CommonModule,
        SharedModule,
        NgForOf,
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        NewsUrlPipe,
        NgStyle,
        NgOptimizedImage,
        RegistryModule,
    ],
  providers: [AccessGuard,],
  exports: [RouterModule],
})
export class NewsModule { }
